import { CheckCircleFilled } from '@ant-design/icons';
import { Button, Table } from 'antd';
import get from 'lodash/get';
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import CityApi from '../../functions/api/partner/CityApi';
import MyUtil from '../../functions/MyUtil';
import TableUtils from '../../functions/TableUtils';

class ListRegion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listCites: [],
      list: [],
      edit: false,
    };
  }

  async componentDidMount() {
    const list = await CityApi.getAll();
    if (list) this.setState({ listCites: list });
  }
  handleEdit = () => {
    const { edit } = this.state;
    this.setState({
      edit: !edit,
    });
  };

  activeFormatter = (cell, row) => {
    const canEdit = MyUtil.hasPermission('/region', 'update');
    return (
      <div className="div-edit">
        {canEdit && (
          <Link to={`/region/edit-city/${row.city_id}`}>
            <Button size="small" onClick={() => this.handleEdit()}>
              <i className="fas fa-edit"></i>
            </Button>
          </Link>
        )}
      </div>
    );
  };

  handleInsertButtonClick = () => {
    const { match_parent } = this.props;

    return this.props.history.push(`${match_parent.url}/add-city`);
  };

  handleChangeList = (list) => {
    this.setState({ listCites: list });
  };

  formatLocation = (cell, row) => {
    const location = {
      mb: 'Miền Bắc',
      mt: 'Miền Trung',
      mn: 'Miền Nam',
    };
    return get(location, cell);
  };

  formatPopular = (isPopular) => {
    return isPopular ? <CheckCircleFilled className="text-primary" /> : null;
  };

  render() {
    const { listCites } = this.state;

    const canAdd = MyUtil.hasPermission(this.props.match_parent.url, 'add');

    const columnRegions = [
      {
        title: 'ID',
        dataIndex: 'city_id',
        key: 'city_id',
        fixed: 'left',
      },
      {
        title: 'Tên thành phố',
        dataIndex: 'city_name',
        key: 'city_name',
        fixed: 'left',
        ...TableUtils.getColumnSearchProps('city_name'),
      },
      {
        title: 'Tên thành phố theo tiếng Anh',
        dataIndex: 'city_name_en',
        key: 'city_name_en',
      },
      {
        title: 'Mã thành phố',
        dataIndex: 'city_code',
        key: 'city_code',
      },
      {
        title: 'Khu vực',
        dataIndex: 'city_location',
        key: 'city_location',
        render: this.formatLocation,
        ...TableUtils.getColumnDropDownFilter(listCites, 'city_location'),
      },
      {
        title: 'Nổi bật',
        dataIndex: 'city_popular',
        render: this.formatPopular,
        align: 'center',
      },
      {
        title: 'Chỉnh sửa',
        render: this.activeFormatter,
        fixed: 'right',
      },
    ];
    return (
      <div className="content">
        {canAdd && (
          <Button
            className="my-3"
            onClick={this.handleInsertButtonClick}
            type="primary"
            size="large"
          >
            Thêm
          </Button>
        )}
        <Table
          rowKey="city_id"
          size="small"
          columns={columnRegions}
          dataSource={listCites}
          scroll={{ x: 'max-content' }}
        />
      </div>
    );
  }
}

export default withRouter(ListRegion);
